import React, { useState } from "react";
import { TimelineModification, TimelineModificationAction } from "../../../types/mes";

interface Props {
  modifications: TimelineModification[];
  onChange: (mods: TimelineModification[]) => void;
  productNames: string[];
  mixers: string[];
  disabled?: boolean;
}

const ACTIONS: TimelineModificationAction[] = ["PRIORITET", "NOĆ", "CIKCAK"];

const TimelineModificationsPanel: React.FC<Props> = ({
  modifications,
  onChange,
  productNames,
  mixers,
  disabled,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [radnja, setRadnja] = useState<TimelineModificationAction>("PRIORITET");
  const [proizvod, setProizvod] = useState(productNames[0] || "");
  const [mikser, setMikser] = useState(mixers[0] || "");
  const [brojZamjesa, setBrojZamjesa] = useState("SVE");
  const [pozicija, setPozicija] = useState(1);

  const handleAdd = () => {
    if (!proizvod || !mikser) return;
    onChange([
      ...modifications,
      {
        Radnja: radnja,
        Proizvod: proizvod,
        Mikser: mikser,
        Broj_zamjesa: brojZamjesa.toUpperCase() === "SVE" ? "SVE" : Number(brojZamjesa) || 1,
        Pozicija: pozicija,
        Od_zamjesa: 1,
      },
    ]);
  };

  return (
    <div className="mes-section timeline-modifications-panel">
      <button
        type="button"
        className="modifications-toggle"
        onClick={() => setExpanded(!expanded)}
        disabled={disabled}
      >
        <span>Izmjene redoslijeda (PRIORITET / NOĆ / CIKCAK)</span>
        <span className="toggle-icon">{expanded ? "▾" : "▸"}</span>
        {modifications.length > 0 && (
          <span className="mod-count">{modifications.length}</span>
        )}
      </button>

      {expanded && (
        <div className="modifications-body">
          <p className="modifications-hint">
            Ostavi prazno ako nema izmjena. Nakon dodavanja regeneriraj timeline.
          </p>

          <div className="mod-form-grid">
            <label>
              Radnja
              <select
                className="select-classic"
                value={radnja}
                onChange={(e) => setRadnja(e.target.value as TimelineModificationAction)}
                disabled={disabled}
              >
                {ACTIONS.map((a) => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </label>
            <label>
              Proizvod
              <select
                className="select-classic"
                value={proizvod}
                onChange={(e) => setProizvod(e.target.value)}
                disabled={disabled || productNames.length === 0}
              >
                {productNames.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            </label>
            <label>
              Mikser
              <select
                className="select-classic"
                value={mikser}
                onChange={(e) => setMikser(e.target.value)}
                disabled={disabled || mixers.length === 0}
              >
                {mixers.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
            </label>
            <label>
              Br. zamjesa
              <input
                className="input-classic"
                value={brojZamjesa}
                onChange={(e) => setBrojZamjesa(e.target.value)}
                placeholder="SVE ili broj"
                disabled={disabled}
              />
            </label>
            <label>
              Pozicija
              <input
                type="number"
                min={1}
                className="input-classic"
                value={pozicija}
                onChange={(e) => setPozicija(Number(e.target.value))}
                disabled={disabled}
              />
            </label>
            <div className="mod-form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={handleAdd}
                disabled={disabled || !proizvod || !mikser}
              >
                Dodaj izmjenu
              </button>
            </div>
          </div>

          {modifications.length > 0 && (
            <>
              <div className="mes-table-wrap">
                <table className="mes-table modifications-table">
                <thead>
                  <tr>
                    <th>Radnja</th>
                    <th>Proizvod</th>
                    <th>Mikser</th>
                    <th>Br. zamjesa</th>
                    <th>Pozicija</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {modifications.map((mod, idx) => (
                    <tr key={idx}>
                      <td>{mod.Radnja}</td>
                      <td>{mod.Proizvod}</td>
                      <td>{mod.Mikser}</td>
                      <td>{mod.Broj_zamjesa}</td>
                      <td>{mod.Pozicija}</td>
                      <td>
                        <button
                          type="button"
                          className="btn-icon-danger"
                          onClick={() => onChange(modifications.filter((_, i) => i !== idx))}
                          disabled={disabled}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              <button
                type="button"
                className="btn-secondary btn-sm"
                onClick={() => onChange([])}
                disabled={disabled}
              >
                Obriši sve izmjene
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TimelineModificationsPanel;
